<template>
  <div class="container bg-white min-h-screen rounded-lg shadow p-8">
    <div class="flex">
      <vs-button
        size="small"
        color="dark"
        type="filled"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="mb-2"
        @click="goBack()"
      ></vs-button>
      <div
        class="ml-5 w-3/4"
        v-for="(projectName, index) in projectNames.slice(0, projectsLength)"
        :key="index"
      >
        <div class="flex items-center space-x-4 mb-4">
          <vs-alert
            color="dark"
            :title="`Project - ${index + 1}`"
            active="true"
            class="flex-grow"
            style="height: 130px"
          >
            <span
              class="text-xl font-extrabold text-pretty vessel-name"
              v-if="getVesselName(projectName)"
              :title="getVesselName(projectName)"
            >
              {{ getVesselName(projectName) }}
            </span>
            <span class="text-xl font-extrabold text-pretty d-block">
              {{ getProjectName(projectName) }}
            </span>
            <span class="text-sm text-pretty d-block">
              {{ getProjectDate(projectName) | only_date_format }}
            </span>
          </vs-alert>

          <div
            v-if="index < projectsLength - 1"
            class="flex justify-center items-center"
          >
            <vs-icon
              icon="code"
              color="dark"
              class="text-xl font-extrabold"
            ></vs-icon>
          </div>
        </div>
      </div>
    </div>
    <div v-if="display === 1">
      <div v-if="matchedFolders.length > 0">
        <h4 class="title">Sections:</h4>
        <ul v-if="matchedFolders.length">
          <div class="row">
            <div
              v-for="(folder, index) in matchedFolders"
              :key="index"
              class="col-md-3"
              @click="showSubFolder(folder)"
            >
              <vs-card actionable class="cardx matched-card">
                <div class="text-center card-content">
                  <h4>{{ folder.folder_name }}</h4>
                </div>
              </vs-card>
            </div>
          </div>
        </ul>
        <div v-else class="text-center">
          <h3>No matching Sections!</h3>
        </div>
      </div>
      <div v-if="unmatchedFolders.length > 0 && (isUserType('A') || isUserType('CL'))">
        <h4 class="text-danger">Unmatched Sections:</h4>
        <ul v-if="unmatchedFolders.length > 0">
          <div v-for="(folder, index) in unmatchedFolders" :key="index">
            <div v-if="folder.length > 0">
              <p class="text-xl h5 title">
                {{ getProjectName(index) }}
              </p>
              <div class="row">
                <div
                  v-for="(sub_folder, sub_index) in folder"
                  :key="sub_index"
                  class="col-md-3"
                >
                  <vs-card actionable class="cardx unmatched-card">
                    <div class="text-center">
                      <h4>{{ sub_folder.folder_name }}</h4>
                    </div>
                  </vs-card>
                </div>
              </div>
            </div>
          </div>
        </ul>
        <div v-else class="text-center">
          <h3>No unMatching Sections!</h3>
        </div>
      </div>
    </div>
    <div v-else-if="display === 2">
      <div v-if="matchedSubFolders.length > 0">
        <div class="d-flex">
          <h4 class="mr-2 title">{{ currentFolder }} :</h4>
          <h4 class="mr-2 text-primary">Sub Folders</h4>
        </div>
        <ul v-if="matchedSubFolders.length" class="">
          <div class="row">
            <div
              v-for="(subFolder, index) in matchedSubFolders"
              :key="index"
              class="col-md-3"
              @click="showSubFolderImage(subFolder)"
            >
              <vs-card actionable class="cardx matched-card">
                <div class="text-center card-content">
                  <h4>{{ subFolder.folder_name }}</h4>
                </div>
              </vs-card>
            </div>
          </div>
        </ul>
        <div v-else class="text-center">
          <h3>No matching subFolders!</h3>
        </div>
      </div>
      <div v-if="checkAllEmptyArray(unmatchedSubFolders) && (isUserType('A') || isUserType('CL'))">
        <h4 class="text-danger">Unmatched Sub Folders:</h4>
        <div v-if="unmatchedSubFolders.length > 0">
          <div v-for="(folder, index) in unmatchedSubFolders" :key="index">
            <div v-if="folder.length > 0">
              <p class="text-xl font-extrabold text-dark">
                {{ getProjectName(index) }}
              </p>
              <div class="row">
                <div
                  v-for="(sub_folder, sub_index) in folder"
                  :key="sub_index"
                  class="col-md-3"
                >
                  <vs-card actionable class="cardx unmatched-card">
                    <div class="text-center">
                      <h4>{{ sub_folder.folder_name }}</h4>
                    </div>
                  </vs-card>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center">
          <h3>No unMatching Sections!</h3>
        </div>
      </div>
    </div>
    <div v-else-if="display === 3">
      <div>
        <div class="d-none">{{ dummy }}</div>
        <h4 class="title">{{ currentFolder }} / {{ currentSubFolder }}</h4>
        <h4 class="title">Images:</h4>
      </div>
      <div
        :class="{
          'grid grid-cols-2 gap-4': projectsLength === 2,
          'grid grid-cols-3 gap-4': projectsLength !== 2,
        }"
      >
        <vs-card
          v-for="(projectName, index) in projectNames.slice(0, projectsLength)"
          :key="index"
          class="cardx relative align-content-center"
        >
          <div
            v-if="currentImage[projectName] && currentImage[projectName].url"
          >
            <div class="absolute m-3" style="top: 50%">
              <vs-button
                radius
                color="dark"
                class="opacity-75"
                @click="showPreImage(projectName)"
                :disabled="currentImage[projectName].index === 0"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="7"
                  stroke="currentColor"
                  class="w-6 h-6 text-white"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15.75 19.5 8.25 12l7.5-7.5"
                  />
                </svg>
              </vs-button>
            </div>

            <div>
              <span class="text-xl text-dark font-bold">
                {{ getProjectName(projectName) }}
              </span>
              <img
                :src="currentImage[projectName].url"
                style="max-height: 600px; object-fit: contain; width: 100%"
                class="mb-2 mt-2"
              />
              <div class="absolute m-2 top-0 right-0">
                <div class="d-flex">
                  <vs-button
                    color="dark"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-download"
                    class="mr-1"
                    title="Download"
                    @click="downloadIMG(currentImage[projectName].url)"
                  >
                  </vs-button>

                  <vs-button
                    color="dark"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-maximize"
                    class="p-0"
                    title="Fullscreen"
                    @click="showImageModal(currentImage[projectName].url)"
                  >
                  </vs-button>
                </div>
              </div>
            </div>

            <div class="absolute m-3" style="top: 50%; right: 0px">
              <vs-button
                radius
                color="dark"
                class="opacity-75"
                @click="showNextImage(projectName)"
                :disabled="
                  currentImage[projectName].index ===
                  images[projectName].length - 1
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="7"
                  stroke="currentColor"
                  class="w-6 h-6 text-white"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m8.25 4.5 7.5 7.5-7.5 7.5"
                  />
                </svg>
              </vs-button>
            </div>
          </div>
          <div v-else>
            <h3 class="text-center">No Images!</h3>
          </div>
        </vs-card>
      </div>
    </div>
    <ImageModal
      :isVisible="imageModal.isShow"
      @close="closeImageModal"
      :imageUrl="imageModal.url"
    />
  </div>
</template>
<script>
import _ from "lodash";
import { mapState } from "vuex";
import ImageModal from "@/layouts/image-modal.vue";
import axios from "axios";

export default {
  components: {
    ImageModal,
  },
  data() {
    return {
      display: 1,
      currentFolder: "",
      currentSubFolder: "",
      firstImageIndex: 0,
      secondImageIndex: 0,
      projectNames: ["first", "second", "third"],
      projectsLength: 0,
      dummy: 0,
      imageModal: {
        isShow: false,
        url: null,
      },
      projects: {},
      projectFolders: {},
      projectSubFolders: {},
      images: {},
      currentImage: {},
      matchedSubFolders: [],
      unmatchedSubFolders: [],
      matchedFolders: [],
      unmatchedFolders: [],
      finalFolders: null,
    };
  },
  computed: {
    ...mapState({
      selectedProjectIds: (state) => state.comparingProjects,
    }),
    getProjectIds() {
      const ids = _.split(this.$route.query.ids, ",").map((id) => parseInt(id));
      return ids || this.selectedProjectIds.length > 0;
    },
  },
  methods: {
    closeImageModal() {
      this.imageModal.isShow = false;
    },
    async getProjects(id) {
      this.$vs.loading();
      let response = await this.getHTTPGetResponse("/projects/get/" + id);
      this.$vs.loading.close();
      return response.data || [];
    },
    async getProjectFolderSubFolder(id) {
      const response = await this.getHTTPGetResponse(
        `/projects/${id}/folder/subfolder/get-folders`
      );
      let data = response.data;
      if (data && data.folders.length) {
        return response.data.folders;
      } else if (data && data.folders.length === 0) {
        this.$vs.notify({
          title: "No Folders for this Project!",
          position: "top-right",
          color: "danger",
        });
        return this.$router.push("/projects");
      }
    },
    async compareProjects() {
      this.$vs.loading();
      const projectIds = this.getProjectIds;

      for (let i = 0; i < projectIds.length; i++) {
        const projectName = this.projectNames[i];
        this.projectFolders[projectName] = await this.getProjectFolderSubFolder(
          projectIds[i]
        );
      }

      const allFoldersAvailable = Object.values(this.projectFolders).every(
        (folders) => folders.length
      );

      if (allFoldersAvailable) {
        const comparedFolders = this.compareFolders(
          ...Object.values(this.projectFolders)
        );
        this.matchedFolders = comparedFolders.matchedFolders;
        this.unmatchedFolders = comparedFolders.unmatchedFolders;
      }

      this.$vs.loading.close();
    },
    showSubFolder(folder) {
      this.currentFolder = folder.folder_name;
      const projectNames = this.projectNames;

      for (let i = 0; i < this.projectsLength; i++) {
        const projectName = projectNames[i];
        this.projectSubFolders[projectName] = this.projectFolders[
          projectName
        ].filter((v) => {
          return (
            this.lowerCase(v.folder_name) === this.lowerCase(folder.folder_name)
          );
        });
      }

      let commonSubFolders = [];

      for (let i = 0; i < this.projectsLength; i++) {
        commonSubFolders.push(
          this.projectSubFolders[projectNames[i]][0].subFolders
        );
      }

      const comparedFolders = this.compareFolders(...commonSubFolders);
      this.matchedSubFolders = comparedFolders.matchedFolders;
      this.unmatchedSubFolders = comparedFolders.unmatchedFolders;
      this.display = 2;
    },
    getFolderByName() {
      let finalProject = [];
      const filterFolders = (project) =>
        project.filter(
          (folder) =>
            this.lowerCase(folder.folder_name) ===
            this.lowerCase(this.currentFolder)
        );

      const filterSubFolders = (folders) => {
        return folders.map((folder) => {
          let filteredSubFolders = folder.subFolders.filter(
            (subfolder) =>
              this.lowerCase(subfolder.folder_name) ===
              this.lowerCase(this.currentSubFolder)
          );
          return {
            ...folder,
            subFolders: filteredSubFolders,
          };
        });
      };

      for (let i = 0; i < this.projectsLength; i++) {
        const projectName = this.projectNames[i];

        const filteredFolders = filterFolders(this.projectFolders[projectName]);
        if (filteredFolders.length > 0) {
          const filteredSubFolders = filterSubFolders(filteredFolders);
          finalProject.push(filteredSubFolders[0]);
        }
      }

      return finalProject;
    },

    async showSubFolderImage(subFolder) {
      this.currentSubFolder = subFolder.folder_name;
      this.finalFolders = this.getFolderByName();
      const finalCompare = this.finalFolders;

      if (finalCompare.length > 0) {
        for (let i = 0; i < this.projectsLength; i++) {
          const projectName = this.projectNames[i];

          this.images[projectName] = await this.getProjectSubFolderImages(
            finalCompare[i].project_id,
            finalCompare[i].subFolders[0].id
          );

          if (this.images[projectName].length > 0) {
            this.$set(this.currentImage, projectName, {
              url:
                this.images[projectName][0].original ||
                this.images[projectName][0].thumbnail,
              index: 0,
            });
          }
        }

        this.display = 3;
      }
    },
    async getProjectSubFolderImages(project_id, sub_folder_id) {
      this.$vs.loading();
      const response = await this.getHTTPGetResponse(
        `projects/${project_id}/subfolder/${sub_folder_id}/image`
      );
      this.$vs.loading.close();
      return response.data.images;
    },
    compareFolders(...foldersArray) {
      // Match folder names case-insensitively (and trimmed). The map key is
      // the normalized name; the display name shown to the user is always
      // taken from whichever project's folder is encountered first.
      const getFolderMap = (folders) => {
        const folderMap = new Map();
        folders.forEach((folder) => {
          folderMap.set(this.lowerCase(folder.folder_name), folder);
        });
        return folderMap;
      };

      const folderMaps = foldersArray.map(getFolderMap);

      const commonFolderNames = [...folderMaps[0].keys()].filter((name) =>
        folderMaps.every((folderMap) => folderMap.has(name))
      );

      const comparedFolders = commonFolderNames.map((name) => {
        const folderObjects = folderMaps.map((folderMap) =>
          folderMap.get(name)
        );

        return {
          folder_name: folderObjects[0].folder_name,
          ...folderObjects[0],
        };
      });

      const unmatchedFolders = [];

      for (let i = 0; i < foldersArray.length; i++) {
        const projectFolders = foldersArray[i];
        // const projectFolderMap = folderMaps[i];

        const unmatchedProjectFolders = projectFolders.filter(
          (folder) => !commonFolderNames.includes(this.lowerCase(folder.folder_name))
        );

        unmatchedFolders.push(unmatchedProjectFolders);
      }

      return {
        matchedFolders: comparedFolders.filter(Boolean),
        unmatchedFolders,
      };
    },
    lowerCase(val) {
      return (val || "").trim().toLowerCase();
    },
    goBack() {
      if (this.display === 1) {
        this.$router.push("/projects");
      }
      this.display -= 1;
    },
    showPreImage(projectName) {
      if (this.currentImage[projectName].index > 0) {
        this.currentImage[projectName].index--;
        const index = this.currentImage[projectName].index;
        this.dummy--;
        const timestamp = Date.now();
        const url =
          this.images[projectName][index].original ||
          this.images[projectName][index].thumbnail + "?timestamp=" + timestamp;
        this.$set(this.currentImage, projectName, { url, index });
      }
    },
    showNextImage(projectName) {
      if (
        this.currentImage[projectName].index <
        this.images[projectName].length - 1
      ) {
        this.currentImage[projectName].index++;
        const index = this.currentImage[projectName].index;
        const timestamp = Date.now();
        const url =
          this.images[projectName][index].original ||
          this.images[projectName][index].thumbnail + "?timestamp=" + timestamp;
        this.$set(this.currentImage, projectName, { url, index });
        this.dummy++;
      }
    },
    createDynamicStructure(structureName, initialValue) {
      const projectIds = this.$store.state.comparingProjects;

      const dummyValues = Array(projectIds.length).fill(initialValue);

      dummyValues.forEach((value, index) => {
        if (this.projectNames.length > index && this.projectNames[index]) {
          this[structureName][this.projectNames[index]] = value;
        } else {
          console.error(`Project name at index ${index} is undefined.`);
        }
      });
    },
    getProjectName(projectName) {
      if (typeof projectName == "number") {
        const project = this.projectNames;
        return (
          (this.projects[project[projectName]] &&
            this.projects[project[projectName]].project &&
            this.projects[project[projectName]].project.name) ||
          ""
        );
      } else {
        return (
          (this.projects[projectName] &&
            this.projects[projectName].project &&
            this.projects[projectName].project.name) ||
          ""
        );
      }
    },
    getProjectDate(projectName) {
      if (typeof projectName == "number") {
        const project = this.projectNames;
        return (
          (this.projects[project[projectName]] &&
            this.projects[project[projectName]].project &&
            this.projects[project[projectName]].project.date) ||
          ""
        );
      } else {
        return (
          (this.projects[projectName] &&
            this.projects[projectName].project &&
            this.projects[projectName].project.date) ||
          ""
        );
      }
    },
    getVesselName(projectName) {
      if (typeof projectName == "number") {
        const project = this.projectNames;
        return (
          (this.projects[project[projectName]] &&
            this.projects[project[projectName]].project &&
            this.projects[project[projectName]].project.vessel &&
            this.projects[project[projectName]].project.vessel.name) ||
          ""
        );
      } else {
        return (
          (this.projects[projectName] &&
            this.projects[projectName].project &&
            this.projects[projectName].project.vessel &&
            this.projects[projectName].project.vessel.name) ||
          ""
        );
      }
    },
    showImageModal(url) {
      this.imageModal.isShow = !this.imageModal.isShow;
      if (this.imageModal.isShow) {
        this.imageModal.url = url || "";
      }
    },
    checkAllEmptyArray(data) {
      return data.length ? data.some((v) => v.length) : true;
    },
    // downloadIMG(imageURL) {
    //   const fileName = this.getFileNameFromUrl(imageURL);
    //   const link = document.createElement("a");
    //   link.href = imageURL;
    //   link.setAttribute("download", fileName);
    //   document.body.appendChild(link);
    //   link.click();
    // },
    async downloadIMG_Backup(imageURL) {
      const encodedURL = encodeURIComponent(imageURL);
      this.axios
        .get(`/s3/download?file=${encodedURL}`, {
          responseType: "blob",
        })
        .then((response) => {
          let data = response.data;
          const fileName = this.getFileNameFromUrl(imageURL);
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        });
    },
    getFileNameFromUrl(url) {
      return url.split("/").pop().split("?")[0]; // Extract file name from URL
    },
    forceFileDownload(response, title) {
      console.log(title);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
  },
  async mounted() {
    this.projectsLength = this.getProjectIds.length;
    await this.createDynamicStructure("projects", {});
    await this.createDynamicStructure("projectFolders", {});
    await this.createDynamicStructure("projectSubFolders", {});
    await this.createDynamicStructure("images", []);
    await this.createDynamicStructure("currentImage", {});

    const comparingProjects = this.getProjectIds;
    if (comparingProjects.length > 0) {
      for (let i = 0; i < comparingProjects.length; i++) {
        this.projects[this.projectNames[i]] = await this.getProjects(
          comparingProjects[i]
        );
      }
      await this.compareProjects();
    } else {
      this.$router.push("/projects");
    }
  },
};
</script>

<style scoped lang="scss">
.badge {
  background-color: rgba(var(--vs-dark), 1);
  font-size: 20px;
  color: white;
  margin-right: 5px;
}
.tile-gap {
  @media (min-width: 768px) {
    margin-left: 25%;
  }
}
.matched-card {
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  height: 100px;
}
.matched-card:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
.unmatched-card {
  background-color: #f8a4a4;
}
.card-content {
  margin-top: 15px;
  height: 100%;
}
.title {
  color: #04497c;
  font-weight: 600;
}
.vessel-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
</style>
